import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import { toast } from "sonner";
import { useAuth } from "@/context/AuthContext";
import { getErrorMessage } from "@/lib/errors";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import { Card } from "@/components/ui/card";

export default function ForcePasswordChange() {
  const { changePassword, logout, user } = useAuth();
  const navigate = useNavigate();
  const [pw, setPw] = useState("");
  const [confirm, setConfirm] = useState("");
  const [error, setError] = useState("");
  const [loading, setLoading] = useState(false);

  const onSubmit = async (e) => {
    e.preventDefault();
    setError("");
    if (pw.length < 8) {
      setError("Wachtwoord moet minimaal 8 tekens bevatten.");
      return;
    }
    if (pw !== confirm) {
      setError("De wachtwoorden komen niet overeen.");
      return;
    }
    setLoading(true);
    try {
      await changePassword(pw);
      toast.success("Wachtwoord bijgewerkt");
      navigate("/dashboard", { replace: true });
    } catch (err) {
      setError(getErrorMessage(err, "Wijzigen mislukt."));
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="flex min-h-screen items-center justify-center bg-background px-4">
      <Card className="w-full max-w-md p-8">
        <h2 className="mb-1 text-kop font-semibold text-foreground">Wachtwoord wijzigen</h2>
        <p className="mb-6 text-body text-muted-foreground">
          Je moet je tijdelijke wachtwoord wijzigen voordat je verder gaat.
        </p>
        <form onSubmit={onSubmit} className="space-y-4">
          <div className="space-y-1.5">
            <Label htmlFor="new">Nieuw wachtwoord</Label>
            <Input
              id="new"
              type="password"
              data-testid="force-password-new-input"
              value={pw}
              onChange={(e) => setPw(e.target.value)}
              required
            />
            <p className="text-data text-muted-foreground">Minimaal 8 tekens.</p>
          </div>
          <div className="space-y-1.5">
            <Label htmlFor="confirm">Herhaal nieuw wachtwoord</Label>
            <Input
              id="confirm"
              type="password"
              data-testid="force-password-confirm-input"
              value={confirm}
              onChange={(e) => setConfirm(e.target.value)}
              required
            />
          </div>
          {error && (
            <p aria-live="polite" className="text-data text-destructive">
              {error}
            </p>
          )}
          <Button
            type="submit"
            data-testid="force-password-submit-button"
            className="w-full"
            disabled={loading}
          >
            {loading ? "Bezig..." : "Opslaan"}
          </Button>
          <button
            type="button"
            onClick={logout}
            className="w-full text-center text-data text-muted-foreground hover:underline"
          >
            Uitloggen
          </button>
        </form>
      </Card>
    </div>
  );
}
